import React, { useState, useEffect } from 'react';
import {
  maskPhoneNumber,
  LoadingGrid,
  formatDateMonth,
} from '../../../../_mexablock/helpers';
import { useGetAll } from '../hooks/ClientesHook';
import { Filter } from '../_modals/Filter';
import { TableList } from '../../../../_mexablock/helpers/components/TableList';
import { MenuComponent } from '../../../../_mexablock/assets/ts/components';

const View: React.FC = () => {
  const [loadingView, setloadingView] = useState(true);
  const [initFilterValues, setInitFilterValues] = useState({
    verified_email: 0,
  });
  const { data, loadingRequest } = useGetAll(initFilterValues);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  const columns: any = [
    {
      id: 'fecha',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) =>
        row?.created_at ? formatDateMonth(row.created_at) : '',
      sortable: true,
    },
    {
      id: 'cliente',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) => row.first_name,
      cell: (row: any) =>
        `${row.first_name} ${row.father_last_name} ${row.mother_last_name}`,
      sortable: true,
    },
    {
      id: 'email',
      name: <div className="fw-bolder text-muted me-5">Correo</div>,
      selector: (row: any) => row.email,
      cell: (row: any) => row.email,
      sortable: true,
    },
    {
      id: 'phone',
      name: <div className="fw-bolder text-muted me-5">Teléfono</div>,
      selector: (row: any) =>
        row?.phone ? (
          maskPhoneNumber(row.phone)
        ) : (
          <div className="badge badge-light-warning">Por asignar</div>
        ),
      sortable: true,
    },
  ];

  MenuComponent.reinitialization();

  const handleFilter = (values: any) => {
    setInitFilterValues({
      verified_email: Number(values.verified_email),
    });
  };
  const handleFilterClean = () => {
    setInitFilterValues({ verified_email: 0 });
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              {/* <Filter
                initFilterValues={initFilterValues}
                onCleanFilter={handleFilterClean}
                onSearchFilter={handleFilter}
              /> */}
              <div className="card-toolbar" title="Nuevo registro"></div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
